var path = '/Users/saulsoto/Documents/workspace/spa/spa-frontend/src/components/ruc/importar-form/form.html';
var html = "<ui-crud-form icon-classes=\"glyph-icon icon-gear\" list-state=home.ruc.list do-submit=vm.doSubmit() view=vm.view> <ui-crud-header> <h2>{{'Administración de RUC' | translate}}</h2> </ui-crud-header> <ui-crud-title>{{ ::vm.title }}</ui-crud-title> <ui-crud-body> <div class=form-group> <fileupload options=vm.uploadOptions title=\"{{'Archivo TXT set.gov.py' | translate}}\" ng-model=vm.model.file></fileupload> </div> </ui-crud-body> </ui-crud-form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/components/ruc/importar-form/form.html
// module id = 1493
// module chunks = 0